import * as React from 'react'
import { View, StyleProp, ViewStyle } from 'react-native'
import { styles } from './styles'

export function Hero({
  style = undefined,
  children = '',
}: React.PropsWithChildren<{ style?: StyleProp<ViewStyle> }>) {
  return <View style={[styles.hero, style]}>{children}</View>
}
